import { Button, Checkbox, JoonUIColor, Typography } from "@joonapp/web-shared"
import { toast } from "react-hot-toast"
import { useTranslation } from "react-i18next"

import { SelectRow } from "../../../../../components/selectRow/SelectRow"
import { SelectRowContainer } from "../../../../../components/selectRowContainer/SelectRowContainer"
import { useUserQuery } from "../../../../../networking/queries"
import {
  useEditParentPanelPasscodeMutation,
  useEditPasscodeMutation,
} from "../../../../../networking/rewards/mutations"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const Requirements = ({ onSubmit }: { onSubmit: () => void }) => {
  const {
    showError,
    currentPasscode,
    hasParentAppRequirement,
    hasParentPanelRequirement,
    onClose,
    setShowError,
    setHasParentAppRequirement,
    setHasParentPanelRequirement,
  } = useParentPasscodeModalStore()
  const editPasscodeMutation = useEditPasscodeMutation()
  const editParentPanelPasscodeMutation = useEditParentPanelPasscodeMutation()
  const { user } = useUserQuery()
  const { t } = useTranslation()

  const handleSubmit = () => {
    const noneSelected = !hasParentAppRequirement && !hasParentPanelRequirement
    if (noneSelected) {
      setShowError(true)
      return
    }
    if (!user) return
    const isSettingPasscode =
      user.account_passcode === null && user.parent_panel_passcode === null
    if (isSettingPasscode) {
      setShowError(false)
      onSubmit()
      return
    }
    if (!currentPasscode) return
    editPasscodeMutation.mutate({
      userId: user.id,
      accountPasscode: hasParentAppRequirement ? currentPasscode : null,
    })
    editParentPanelPasscodeMutation.mutate({
      userId: user.id,
      parentPanelPasscode: hasParentPanelRequirement ? currentPasscode : null,
    })
    toast.success(t("PPC_TOAST_REQ_UPDATED"))
    onClose()
  }

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="bodyBold">{t("PPC_REQUIRE_WHEN")}</Typography>

      <SelectRowContainer>
        <SelectRow
          hideBorder
          showBorderBottom
          onClick={() => setHasParentAppRequirement(!hasParentAppRequirement)}
        >
          <Typography variant="bodySmall">{t("PPC_THE_PARENT_APP")}</Typography>
          <Checkbox
            name="parentAppRequirement"
            selected={hasParentAppRequirement}
            onChange={() => {}}
            hideBorder
          />
        </SelectRow>
        <SelectRow
          hideBorder
          onClick={() =>
            setHasParentPanelRequirement(!hasParentPanelRequirement)
          }
        >
          <Typography variant="bodySmall">
            {t("PPC_THE_PARENT_PANEL")}
          </Typography>
          <Checkbox
            name="parentPanelRequirement"
            selected={hasParentPanelRequirement}
            onChange={() => {}}
            hideBorder
          />
        </SelectRow>
      </SelectRowContainer>

      <Button text={t("QUEST_SAVE")} onClick={handleSubmit} fullWidth />
      {showError && (
        <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
          {t("PPC_ERR_SELECT_ONE")}
        </Typography>
      )}
    </div>
  )
}

export default Requirements
